import { FC, SVGProps } from 'react';

export const ImportIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M16.75 5C16.75 4.58579 16.4142 4.25 16 4.25C15.5858 4.25 15.25 4.58579 15.25 5V16.0454C15.25 16.2123 15.0576 16.3058 14.9264 16.2027L12.9633 14.6603C12.6376 14.4044 12.1661 14.4609 11.9102 14.7866C11.6543 15.1123 11.7109 15.5838 12.0366 15.8397L15.5366 18.5897C15.8086 18.8034 16.1914 18.8034 16.4633 18.5897L19.9633 15.8397C20.289 15.5838 20.3456 15.1123 20.0897 14.7866C19.8338 14.4609 19.3623 14.4044 19.0366 14.6603L17.0735 16.2027C16.9423 16.3058 16.75 16.2123 16.75 16.0454V5Z"
			fill="currentColor"
		/>
		<path
			d="M5.75 14C5.75 13.3096 6.30964 12.75 7 12.75H11C11.4142 12.75 11.75 12.4142 11.75 12C11.75 11.5858 11.4142 11.25 11 11.25H7C5.48122 11.25 4.25 12.4812 4.25 14V24C4.25 25.5188 5.48122 26.75 7 26.75H25C26.5188 26.75 27.75 25.5188 27.75 24V14C27.75 12.4812 26.5188 11.25 25 11.25H21.5C21.0858 11.25 20.75 11.5858 20.75 12C20.75 12.4142 21.0858 12.75 21.5 12.75H25C25.6904 12.75 26.25 13.3096 26.25 14V24C26.25 24.6904 25.6904 25.25 25 25.25H7C6.30964 25.25 5.75 24.6904 5.75 24V14Z"
			fill="currentColor"
		/>
	</svg>
);
